import styled from 'styled-components';

export const Container = styled.div`
  &.Loader{
		position: relative;
		width: 208px;
		height: 208px;
		user-select: none;
		box-sizing: border-box;
	}
	&.LoaderBg{
		width: 100%;
		height: 100%;
		border-radius: 50%;
		border: 15px solid #CADFFC;
		box-sizing: border-box;
	}
	&.SpinerHolderOne{
		position: absolute;
		top:0;
		left:0;
		overflow: hidden;
		width: 50%;
		height: 50%;
		background: transparent;
		box-sizing: border-box;
	}
	&.SpinerHolderTwo{
		position: absolute;
		top:0;
		left:0;
		overflow: hidden;
		width: 100%;
		height: 100%;
		background: transparent;
		box-sizing: border-box;
	}
	&.LoaderSpiner{
		width: 200%;
		height: 200%;
		border-radius: 50%;
		border: 15px solid #1C62EF;
		box-sizing: border-box;
	}  
	&.Animate025A{
		transform: rotate(90deg);
		transform-origin: 100% 100%;
	}
	&.Animate2550A{
		transform: rotate(180deg);
		transform-origin: 100% 100%;
	}
	&.Animate025B{
		transform: rotate(-90deg);
		transform-origin: 100% 100%;
	}
	&.Animate2550B{
		transform: rotate(-90deg);
		transform-origin: 100% 100%;
	}
	&.Animate5075A{
		transform: rotate(270deg);
		transform-origin: 100% 100%;
	}
	&.Animate5075B{
		transform: rotate(-90deg);
		transform-origin:100% 100%;
	}
	&.Animate75100A{
		transform: rotate(0deg);
		transform-origin: 100% 100%;
	}
	&.Animate75100B{
		transform: rotate(-90deg);
		transform-origin: 100% 100%;
	}
`;

export const StyledH3 = styled.h3`
  padding-top:22%;
  color: #000;
  font-family: OpenSans, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 45.3333px;
  line-height: 59px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  letter-spacing: -0.01em;
  color: #263238;
`;

export const StyledParagraph = styled.p`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #263238;
`;